import { useScrollReveal } from '@/hooks/useScrollReveal';
import { locationAdvantages } from '@/mocks/landingData';

export default function Location() {
  useScrollReveal('.location-reveal', 0.1);

  return (
    <section id="location" className="py-10 md:py-16 bg-cream">
      <div className="section-padding">
        <div className="max-w-3xl mx-auto text-center mb-6 md:mb-10">
          <div className="location-reveal scroll-reveal">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 bg-primary/5 border border-primary/10 rounded-full font-body text-[10px] md:text-xs tracking-[0.2em] uppercase text-primary">
              <span className="w-1.5 h-1.5 bg-gold rounded-full" />
              Strategic Location
            </span>
          </div>
          <h2 className="location-reveal scroll-reveal font-display text-2xl md:text-4xl lg:text-5xl text-charcoal font-bold mt-4 md:mt-5 leading-tight">
            Perfectly Located On <span className="text-gradient-gold">Bangalore's Growth Axis</span>
          </h2>
          <p className="location-reveal scroll-reveal font-body text-sm md:text-base text-charcoal/60 mt-3 md:mt-4 max-w-2xl mx-auto leading-relaxed">
            4W46+8JM, Promenade Rd, Thornahalli, Karnataka 563130 — strategically located with access to VIT University, Garden City University, and Sharanya Narayani International School. Confident Auriga sits on the Bangalore–Chennai corridor, approximately 50 km from Bangalore city center, offering seamless connectivity via major highways and arterial roads. The location combines peaceful suburban living with the economic advantages of being close to one of India's fastest-growing tech hubs. Whether you commute to Bangalore for work or seek a serene retirement destination, these premium plots near Bangalore provide the perfect balance of accessibility and tranquility for land investment near Bangalore.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-10 max-w-6xl mx-auto">
          <div className="location-reveal scroll-reveal rounded-2xl overflow-hidden border border-cream-dark/50 shadow-xl relative group" style={{ filter: 'saturate(0.8)' }}>
            <div className="absolute top-0 left-0 right-0 h-16 bg-gradient-to-b from-cream via-cream/95 to-transparent z-10 pointer-events-none" />
            <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-cream via-cream/90 to-transparent z-10 pointer-events-none" />
            <div className="absolute inset-0 rounded-2xl border border-white/20 pointer-events-none z-20" />
            <iframe
              src="https://maps.google.com/maps?q=4W46%2B8JM%2C%20Promenade%20Rd%2C%20Thornahalli%2C%20Karnataka%20563130&t=&z=15&ie=UTF8&iwloc=&output=embed"
              width="100%"
              height="100%"
              style={{ border: 0, minHeight: '320px' }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Confident Auriga Location - 4W46+8JM, Promenade Rd, Thornahalli, Karnataka 563130"
              className="w-full h-full md:min-h-[440px]"
            />
            <div className="absolute bottom-4 left-4 z-30 bg-white/90 backdrop-blur-md rounded-xl px-4 py-2.5 shadow-lg border border-cream-dark/30">
              <div className="flex items-center gap-2">
                <div className="w-7 h-7 rounded-full bg-primary/10 flex items-center justify-center">
                  <i className="ri-map-pin-fill text-primary text-sm"></i>
                </div>
                <div className="text-left">
                  <p className="font-body text-[11px] text-charcoal/70 leading-tight">Confident Auriga</p>
                  <p className="font-body text-xs text-charcoal font-medium leading-tight">Promenade Rd, Thornahalli</p>
                </div>
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-4 justify-center">
            {locationAdvantages.map((item, index) => (
              <div
                key={item.title}
                className="location-reveal scroll-reveal bg-white rounded-2xl p-5 md:p-6 border border-cream-dark/50 hover:border-gold/30 transition-all duration-500 hover:-translate-y-1 hover:shadow-lg hover:shadow-gold/5 group"
                style={{ transitionDelay: `${index * 100}ms` }}
              >
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 md:w-11 md:h-11 rounded-xl bg-primary/5 flex items-center justify-center flex-shrink-0 group-hover:bg-gold/10 transition-colors duration-500">
                    <i className={`${item.icon} text-primary text-base md:text-lg group-hover:text-gold transition-colors duration-500`}></i>
                  </div>
                  <div>
                    <h3 className="font-display text-sm md:text-lg text-charcoal font-semibold mb-1">{item.title}</h3>
                    <p className="font-body text-xs md:text-sm text-charcoal/60 leading-relaxed">{item.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}